// Same rules as the server (src/utils/gstin.js): format, state code, check digit.
const CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const PATTERN = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9A-Z]Z[0-9A-Z]$/;
const SPECIAL = /^[0-9]{4}[A-Z]{3}[0-9]{5}[A-Z0-9]{3}$|^9[79][0-9]{2}[A-Z]{3}[0-9]{5}[A-Z0-9]{3}$/;

export function gstinError(raw) {
  const g = String(raw || '').trim().toUpperCase();
  if (!g) return null;
  if (g.length !== 15) return 'A GSTIN has 15 characters';
  if (SPECIAL.test(g)) return null;
  if (!PATTERN.test(g)) return 'Expected 2-digit state code, 10-character PAN, entity number, Z, check digit';
  const state = Number(g.slice(0, 2));
  if (!((state >= 1 && state <= 38) || state === 97 || state === 99)) return `${g.slice(0, 2)} is not a GST state code`;
  let sum = 0;
  for (let i = 0; i < 14; i += 1) {
    const prod = CHARS.indexOf(g[i]) * (i % 2 === 0 ? 1 : 2);
    sum += Math.floor(prod / 36) + (prod % 36);
  }
  return CHARS[(36 - (sum % 36)) % 36] === g[14] ? null : 'The check digit doesn’t match — check for a typo';
}
